module.exports = __webpack_public_path__ + "6aa3a04b54aaae027e3b5037bb37969a.fbx";